import React, { useContext } from 'react';
import { MainHeader } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { useLocation } from 'react-router-dom';
import { BrandContext } from '../../../contextProviders/brandContext';
import { useResponsiveConfig } from '../../../hooks/responsiveConfigSwap';
import { HorizontalMenu } from './horizontalMenu';
import { HamburgerMenu } from './hamburgerMenu';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';

const environment = process.env.REACT_APP_ENV;

export const CspHeader = () => {
  const location = useLocation();
  const verification = location.pathname.includes(CSPUrlsMap.verification.url);
  const verifyEmailPath = location.pathname.includes(CSPUrlsMap.verifyEmail.url);
  const verifyPhonePath = location.pathname.includes(CSPUrlsMap.verifySms.url);
  const authErrorPath = location.pathname.includes(CSPUrlsMap.authErrorPage.url);
  const showNoHeader = verification || verifyEmailPath || verifyPhonePath || authErrorPath;

  const {
    activeBrandContext: {
      brand,
      cspConfiguration: { header: customHeaderConfig, headerLogo }
    }
  } = useContext(BrandContext);

  const cspHeaderLogo = [environment !== 'prod' ? headerLogo.nonprod : headerLogo.prod];

  const largeConfigStyle = customHeaderConfig?.layoutConfig?.large || 'horizontal';
  const smallConfigStyle = customHeaderConfig?.layoutConfig?.small || 'hamburger';

  const largeConfig =
    largeConfigStyle === 'horizontal' ? (
      <HorizontalMenu cspHeaderLogo={cspHeaderLogo} />
    ) : (
      <HamburgerMenu cspHeaderLogo={cspHeaderLogo} />
    );
  const smallConfig =
    smallConfigStyle === 'horizontal' ? (
      <HorizontalMenu cspHeaderLogo={cspHeaderLogo} />
    ) : (
      <HamburgerMenu cspHeaderLogo={cspHeaderLogo} />
    );
  const headerLayoutConfig = useResponsiveConfig({
    configDefinition: {
      default: {
        headerConfig: largeConfig
      },
      1040: {
        // Hamburger menu
        headerConfig: smallConfig
      }
    }
  });

  if (showNoHeader) {
    return (
      <MainHeader
        {...brand}
        logos={cspHeaderLogo}
      />
    );
  }

  return headerLayoutConfig?.headerConfig || largeConfig;
};
